module.exports = __webpack_public_path__ + "static/media/21ECLAC30.b6f486a4.jpg";